import dayjs from "dayjs";
import { apiRequest } from "./api";

export async function createReportIssue(data: CreateReportIssueDto) {
  const response = await apiRequest<any>("post", "/reportIssues/create", data);
  return response;
}

export async function getReportIssueByUuid(uuid: string) {
  if (uuid) {
    const response = await apiRequest<any>(
      "get",
      `/reportIssues/find-by-uuid?uuid=${uuid}`
    );
    return response;
  }
}

export async function addAnalystToReportIssue(
  reportUuid: string,
  userUuid: string
) {
  if (reportUuid && userUuid) {
    const response = await apiRequest<any>(
      "get",
      `/reportIssues/add-involvedFunctions-by-reportUuid?reportUuid=${reportUuid}&userUuid=${userUuid}`
    );
    return response;
  }
}

export async function assignUsersReportIssue(
  uuid: string,
  data: AssignUsersReportDto
) {
  const response = await apiRequest<any>(
    "put",
    `/reportIssues/update-add-users?uuid=${uuid}`,
    data
  );
  return response;
}

export async function removeAnalystToReportIssue(
  reportUuid: string,
  userUuid: string
) {
  if (reportUuid && userUuid) {
    const response = await apiRequest<any>(
      "get",
      `/reportIssues/remove-involvedFunctions-by-reportUuid?reportUuid=${reportUuid}&userUuid=${userUuid}`
    );
    return response;
  }
}

export async function getReportIssueByReportUuid(reportUuid: string) {
  if (reportUuid) {
    const response = await apiRequest<any>(
      "get",
      `/reportIssues/find-by-reportUuid?reportUuid=${reportUuid}`
    );
    return response;
  }
}

export async function getReportIssuesListAndSearch(
  page: number,
  itemsPerPage: number,
  search?: string,
  step?: string,
  status?: string[],
  issuePriorities?: string[],
  initDate?: string,
  endDate?: string
): Promise<any> {
  let query = "?";
  let issuePrioritiesSearch: string[] = [];
  let statusSearch: string[] = [];

  if (status && status.length) {
    statusSearch = status.map((status) => `status=${status}&`);
  }

  if (issuePriorities && issuePriorities.length) {
    issuePrioritiesSearch = issuePriorities.map(
      (issuePriority) => `issuePriorities=${issuePriority}&`
    );
  }

  query += page ? `page=${page}&` : "";
  query += itemsPerPage ? `itemsPerPage=${itemsPerPage}&` : "";
  query += search ? `search=${search}&` : "";

  if (issuePrioritiesSearch.length) {
    query += issuePrioritiesSearch.join("");
  }

  if (statusSearch.length) {
    query += statusSearch.join("");
  }

  if (step) {
    query += `step=${step}&`;
  }

  query += initDate ? `initDate=${dayjs(initDate).toISOString()}&` : "";
  query += endDate ? `endDate=${dayjs(endDate).toISOString()}` : "";

  return await apiRequest<any>("get", `/reportIssues/list${query}`);
}

export async function closeReportIssue(reportIssueUuid: string) {
  if (reportIssueUuid) {
    const response = await apiRequest<any>(
      "put",
      `/reportIssues/closed?uuid=${reportIssueUuid}`
    );
    return response;
  }
}

export async function updateReportIssue(
  uuid: string,
  data: UpdateReportIssueDto
) {
  if (uuid) {
    const response = await apiRequest<any>(
      "put",
      `/reportIssues/update?uuid=${uuid}`,
      data
    );
    return response;
  }
}

export async function deleteReportIssue(uuid: string) {
  if (uuid) {
    const response = await apiRequest<DeleteDto>(
      "delete",
      `/reportIssues/soft-delete?uuid=${uuid}`
    );
    return response;
  }
}
